import { render } from "./ResearchBox.vue?vue&type=template&id=0e273b0a"
import script from "./ResearchBox.vue?vue&type=script&lang=js"
export * from "./ResearchBox.vue?vue&type=script&lang=js"

import exportComponent from "/root/mentoringplatform-acm/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__